import { LayoutGenerator } from "./utils/layoutGenerator"
import { Text } from "materials/text/menus/model"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
import { Select } from "materials/select/menus/model"
// import { More } from "../more/model"
import { Tabs } from "materials/tabs/menus/model"
import { Input } from "materials/input/menus/model"
import { Radio } from "materials/radio/menus/model"
import { AutoLayout } from "materials/autoLayout/menus/model"
/**
 * 门户文本默认配置数据
 */
export const home = [
  // {
  //   styleName: "自由布局",
  //   thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
  //   pluginName: ["searchComponentPlugin"],
  //   appId: "",
  //   background: [
  //     {
  //       color: "rgba(0, 0, 0, 0.24)",
  //       isThemeColor: false,
  //       label: "颜色",
  //       type: "color"
  //     }
  //   ],
  //   titleOptions: [
  //     {
  //       type: "top",
  //       elementOptions: []
  //     },
  //     {
  //       type: "bottom",
  //       elementOptions: []
  //     },
  //     {
  //       type: "left",
  //       elementOptions: []
  //     },
  //     {
  //       type: "right",
  //       elementOptions: []
  //     }
  //   ],
  //   rows: new LayoutGenerator({
  //     // row的数量需与tab的数量同步
  //     rows: [
  //       {
  //         height: "100%",
  //         cols: [
  //           {
  //             width: "100%",
  //             disableSetData: true,
  //             elementOptions: [
  //               new Tabs({
  //                 top: 40,
  //                 left: 44,
  //                 width: 820,
  //                 elementInLayoutId: 0,
  //                 color: "rgba(255,255,255,1)",
  //                 tabWidth: 92,
  //                 tabHeight: 44,
  //                 hoverBgColor: "rgba(255, 255, 255, 0.32)",
  //                 textAlign: "center",
  //                 isNoSyncData: true, //不同步数据
  //                 searchType: "searchTabs",
  //                 borderTopLeftRadius: 10,
  //                 borderTopRightRadius: 10,
  //                 borderBottomLeftRadius: 10,
  //                 borderBottomRightRadius: 10,
  //                 bgColor: "rgba(255,255,255,0)",
  //                 paddingTypeFlag: 2,
  //                 paddingRight: 16,
  //                 paddingLeft: 16,
  //                 textLimitLines: 6,
  //                 marginRight: 4,
  //                 fontWeight: 600,
  //                 tabsList: [
  //                   { name: "馆藏书目检索", content: "馆藏书目检索" },
  //                   { name: "数字资源检索", content: "数字资源检索" },
  //                   { name: "站内检索", content: "站内检索" }
  //                 ]
  //               }),
  //               new Select({
  //                 top: 100,
  //                 left: 44,
  //                 width: 116,
  //                 height: 50,
  //                 liIsSameSize: false,
  //                 liHeight: 42,
  //                 liWidth: 116,
  //                 elementInLayoutId: 1,
  //                 selectBgColor: "rgba(255, 255, 255, 0.9)",
  //                 selectFontColor: "rgba(0,0,0,1)",
  //                 selectLiColor: "rgba(29, 107, 233, 1)",
  //                 placeHolderFontColor: "rgba(0,0,0,1)",
  //                 liFontColor: "rgba(0, 0, 0, 0.8)",
  //                 primaryLiBg: "rgba(255,255,255,0.8)",
  //                 selectLiBg: "rgba(255, 255, 255, 1)",
  //                 hoverLiBg: "rgba(240, 243, 250, 1)",
  //                 searchType: "searchSelect",
  //                 borderTopLeftRadius: 10,
  //                 borderBottomLeftRadius: 10,
  //                 color: "rgba(0,0,0,1)",
  //                 selectFontSize: 16,
  //                 value: "全部",
  //                 liBorderTopLeftRadius: 8,
  //                 liBorderTopRightRadius: 8,
  //                 liBorderBottomRightRadius: 8,
  //                 liBorderBottomLeftRadius: 8,
  //                 liBorderWidth: [0, 0, 0, 0],
  //                 selectOptions: [
  //                   {
  //                     label: "全部",
  //                     value: "https://www.chaoxing.com/"
  //                   },
  //                   {
  //                     label: "图书",
  //                     value: ""
  //                   },
  //                   {
  //                     label: "期刊",
  //                     value: ""
  //                   },
  //                   {
  //                     label: "报纸",
  //                     value: ""
  //                   }
  //                 ]
  //               }),
  //               new Input({
  //                 top: 100,
  //                 left: 160,
  //                 width: 703,
  //                 height: 50,
  //                 elementInLayoutId: 2,
  //                 textPaddingTypeFlag: 2,
  //                 fontSize: 16,
  //                 paddingLeft: 16,
  //                 paddingRight: 120,
  //                 placeHolderFontSize: 16,
  //                 showDelIcon: true,
  //                 borderTopRightRadius: 10,
  //                 borderBottomRightRadius: 10,
  //                 borderColor: "rgba(0, 0, 0, 0.1)",
  //                 borderWidth: [0, 0, 0, 1],
  //                 bgColor: "rgba(255,255,255,0.9)",
  //                 searchType: "searchInput"
  //               }),
  //               new Button({
  //                 top: 104,
  //                 left: 758,
  //                 width: 100,
  //                 height: 42,
  //                 elementInLayoutId: 3,
  //                 content: "搜索",
  //                 searchType: "searchButton",
  //                 borderTopRightRadius: 6,
  //                 borderBottomRightRadius: 6,
  //                 borderTopLeftRadius: 6,
  //                 borderBottomLeftRadius: 6,
  //                 bgColor: "rgba(29, 107, 233, 1)",
  //                 hoverBackground: "rgba(6, 80, 200, 1)",
  //                 bgColorIsThemeColor: true,
  //                 fontSize: 16,
  //                 borderWidth: 0,
  //                 background: [
  //                   {
  //                     isThemeColor: true,
  //                     label: "颜色",
  //                     type: "color",
  //                     color: "rgba(29, 107, 233, 1)"
  //                   }
  //                 ]
  //               }),
  //               new Radio({
  //                 rect_id: 0,
  //                 top: 166,
  //                 left: 44,
  //                 width: 820,
  //                 height: 44,
  //                 elementInLayoutId: 4,
  //                 searchType: "searchRadio",
  //                 color: "rgba(255,255,255,1)",
  //                 hoverColor: "rgba(255,255,255,1)",
  //                 radioLists: [
  //                   {
  //                     name: "书名",
  //                     content: "书名"
  //                   },
  //                   {
  //                     name: "作者",
  //                     content: "作者"
  //                   },
  //                   {
  //                     name: "出版社",
  //                     content: "出版社"
  //                   }
  //                 ]
  //               })
  //             ]
  //           }
  //         ]
  //       }
  //     ]
  //   }).rows
  // },
  {
    styleId: 1,
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["searchComponentPlugin"],
    appId: "",
    background: [
      {
        color: "rgba(0, 0, 0, 0.24)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Tabs({
                  top: 40,
                  left: 44,
                  width: 820,
                  elementInLayoutId: 0,
                  color: "rgba(255,255,255,1)",
                  tabWidth: 92,
                  tabHeight: 44,
                  hoverBgColor: "rgba(255, 255, 255, 0.32)",
                  textAlign: "center",
                  isNoSyncData: true, //不同步数据
                  searchType: "searchTabs",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10,
                  bgColor: "rgba(255,255,255,0)",
                  paddingTypeFlag: 2,
                  paddingRight: 16,
                  paddingLeft: 16,
                  textLimitLines: 6,
                  marginRight: 4,
                  fontWeight: 600,
                  tabsList: [
                    { name: "馆藏书目检索", content: "馆藏书目检索" },
                    { name: "数字资源检索", content: "数字资源检索" },
                    { name: "站内检索", content: "站内检索" }
                  ]
                }),
                new AutoLayout({
                  elementInLayoutId: 1,
                  searchType: "searchAutoLayout",
                  width: 1000,
                  height: 70,
                  rowColDirection: "horizon",
                  top: 100,
                  left: 44,
                  elementOptions: [
                    new Select({
                      elementInLayoutId: 1,
                      elementInAutoLayoutId: 0,
                      top: 100,
                      left: 44,
                      width: 116,
                      height: 50,
                      liIsSameSize: false,
                      liHeight: 42,
                      liWidth: 116,
                      selectBgColor: "rgba(255, 255, 255, 0.9)",
                      selectFontColor: "rgba(0,0,0,1)",
                      selectLiColor: "rgba(29, 107, 233, 1)",
                      placeHolderFontColor: "rgba(0,0,0,1)",
                      liFontColor: "rgba(0, 0, 0, 0.8)",
                      primaryLiBg: "rgba(255,255,255,0.8)",
                      selectLiBg: "rgba(255, 255, 255, 1)",
                      hoverLiBg: "rgba(240, 243, 250, 1)",
                      searchType: "searchSelect",
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 10,
                      color: "rgba(0,0,0,1)",
                      selectFontSize: 16,
                      value: "全部",
                      liBorderTopLeftRadius: 8,
                      liBorderTopRightRadius: 8,
                      liBorderBottomRightRadius: 8,
                      liBorderBottomLeftRadius: 8,
                      liBorderWidth: [0, 0, 0, 0],
                      selectOptions: [
                        {
                          label: "全部",
                          value: "https://www.chaoxing.com/"
                        },
                        {
                          label: "图书",
                          value: ""
                        },
                        {
                          label: "期刊",
                          value: ""
                        },
                        {
                          label: "报纸",
                          value: ""
                        }
                      ]
                    }),
                    new Input({
                      elementInLayoutId: 1,
                      elementInAutoLayoutId: 1,
                      top: 100,
                      left: 160,
                      width: 703,
                      height: 50,
                      textPaddingTypeFlag: 2,
                      fontSize: 16,
                      paddingLeft: 16,
                      paddingRight: 120,
                      placeHolderFontSize: 16,
                      showDelIcon: true,
                      borderTopRightRadius: 10,
                      borderBottomRightRadius: 10,
                      borderColor: "rgba(0, 0, 0, 0.1)",
                      borderWidth: [0, 0, 0, 1],
                      bgColor: "rgba(255,255,255,0.9)",
                      searchType: "searchInput"
                    }),
                    new Button({
                      elementInLayoutId: 1,
                      elementInAutoLayoutId: 2,
                      top: 104,
                      left: 758,
                      width: 100,
                      height: 42,
                      content: "搜索",
                      searchType: "searchButton",
                      borderTopRightRadius: 6,
                      borderBottomRightRadius: 6,
                      borderTopLeftRadius: 6,
                      borderBottomLeftRadius: 6,
                      bgColor: "rgba(29, 107, 233, 1)",
                      hoverBackground: "rgba(6, 80, 200, 1)",
                      bgColorIsThemeColor: true,
                      fontSize: 16,
                      borderWidth: 0,
                      background: [
                        {
                          isThemeColor: true,
                          label: "颜色",
                          type: "color",
                          color: "rgba(29, 107, 233, 1)"
                        }
                      ]
                    }),
                  ]
                }),
                new Radio({
                  rect_id: 0,
                  top: 166,
                  left: 44,
                  width: 820,
                  height: 44,
                  elementInLayoutId: 4,
                  searchType: "searchRadio",
                  color: "rgba(255,255,255,1)",
                  hoverColor: "rgba(255,255,255,1)",
                  radioLists: [
                    {
                      name: "书名",
                      content: "书名"
                    },
                    {
                      name: "作者",
                      content: "作者"
                    },
                    {
                      name: "出版社",
                      content: "出版社"
                    }
                  ]
                })
              ]
            }
          ]
        }
      ]
    }).rows
  },
  {
    styleId: 2,
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["searchComponentPlugin"],
    appId: "",
    background: [
      {
        color: "rgba(0, 0, 0, 0.24)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Tabs({
                  top: 40,
                  left: 44,
                  width: 820,
                  elementInLayoutId: 0,
                  color: "rgba(255,255,255,1)",
                  tabWidth: 92,
                  tabHeight: 44,
                  hoverBgColor: "rgba(255, 255, 255, 0.32)",
                  textAlign: "center",
                  isNoSyncData: true, //不同步数据
                  searchType: "searchTabs",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10,
                  bgColor: "rgba(255,255,255,0)",
                  paddingTypeFlag: 2,
                  paddingRight: 16,
                  paddingLeft: 16,
                  textLimitLines: 6,
                  marginRight: 4,
                  fontWeight: 600,
                  tabsList: [
                    { name: "馆藏书目检索", content: "馆藏书目检索" },
                    { name: "数字资源检索", content: "数字资源检索" },
                    { name: "站内检索", content: "站内检索" }
                  ]
                }),
                new AutoLayout({
                  elementInLayoutId: 1,
                  searchType: "searchAutoLayout",
                  width: 800,
                  height: 70,
                  rowColDirection: "horizon",
                  top: 100,
                  left: 44,
                  elementOptions: [
                    new Select({
                      elementInLayoutId: 1,
                      elementInAutoLayoutId: 0,
                      top: 100,
                      left: 44,
                      width: 116,
                      height: 50,
                      liIsSameSize: false,
                      liHeight: 42,
                      liWidth: 116,
                      selectBgColor: "rgba(255, 255, 255, 0.9)",
                      selectFontColor: "rgba(0,0,0,1)",
                      selectLiColor: "rgba(29, 107, 233, 1)",
                      placeHolderFontColor: "rgba(0,0,0,1)",
                      liFontColor: "rgba(0, 0, 0, 0.8)",
                      primaryLiBg: "rgba(255,255,255,0.8)",
                      selectLiBg: "rgba(255, 255, 255, 1)",
                      hoverLiBg: "rgba(240, 243, 250, 1)",
                      searchType: "searchSelect",
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 10,
                      color: "rgba(0,0,0,1)",
                      selectFontSize: 16,
                      value: "全部",
                      liBorderTopLeftRadius: 8,
                      liBorderTopRightRadius: 8,
                      liBorderBottomRightRadius: 8,
                      liBorderBottomLeftRadius: 8,
                      liBorderWidth: [0, 0, 0, 0],
                      selectOptions: [
                        {
                          label: "全部",
                          value: "https://www.chaoxing.com/"
                        },
                        {
                          label: "图书",
                          value: ""
                        },
                        {
                          label: "期刊",
                          value: ""
                        },
                        {
                          label: "报纸",
                          value: ""
                        }
                      ]
                    }),
                    new Input({
                      elementInLayoutId: 1,
                      elementInAutoLayoutId: 1,
                      top: 100,
                      left: 160,
                      width: 703,
                      height: 50,
                      textPaddingTypeFlag: 2,
                      fontSize: 16,
                      paddingLeft: 16,
                      paddingRight: 120,
                      placeHolderFontSize: 16,
                      showDelIcon: true,
                      borderTopRightRadius: 10,
                      borderBottomRightRadius: 10,
                      borderColor: "rgba(0, 0, 0, 0.1)",
                      borderWidth: [0, 0, 0, 1],
                      bgColor: "rgba(255,255,255,0.9)",
                      searchType: "searchInput"
                    }),
                  ]
                }),
                new Button({
                  elementInLayoutId: 3,
                  top: 104,
                  left: 758,
                  width: 100,
                  height: 42,
                  content: "搜索",
                  searchType: "searchButton",
                  borderTopRightRadius: 6,
                  borderBottomRightRadius: 6,
                  borderTopLeftRadius: 6,
                  borderBottomLeftRadius: 6,
                  bgColor: "rgba(29, 107, 233, 1)",
                  hoverBackground: "rgba(6, 80, 200, 1)",
                  bgColorIsThemeColor: true,
                  fontSize: 16,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color",
                      color: "rgba(29, 107, 233, 1)"
                    }
                  ]
                }),
                new Radio({
                  rect_id: 0,
                  top: 166,
                  left: 44,
                  width: 820,
                  height: 44,
                  elementInLayoutId: 4,
                  searchType: "searchRadio",
                  color: "rgba(255,255,255,1)",
                  hoverColor: "rgba(255,255,255,1)",
                  radioLists: [
                    {
                      name: "书名",
                      content: "书名"
                    },
                    {
                      name: "作者",
                      content: "作者"
                    },
                    {
                      name: "出版社",
                      content: "出版社"
                    }
                  ]
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = []

/**
 * app搜索默认配置数据
 */
export const appHome = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["searchComponentPlugin"],
    appId: "",
    background: [
      {
        color: "rgba(0, 0, 0, 0.24)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Tabs({
                  top: 30,
                  left: 44,
                  width: 500,
                  elementInLayoutId: 0,
                  color: "rgba(255,255,255,1)",
                  tabWidth: 92,
                  tabHeight: 38,
                  hoverBgColor: "rgba(61, 130, 242, 1)",
                  textAlign: "center",
                  isNoSyncData: true, //不同步数据
                  searchType: "searchTabs",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  bgColor: "rgba(255,255,255,0)",
                  tabsList: [
                    { name: "图书", content: "图书" },
                    { name: "期刊", content: "期刊" },
                    { name: "会议", content: "会议" }
                  ]
                }),
                new Select({
                  top: 68,
                  left: 44,
                  width: 100,
                  height: 46,
                  elementInLayoutId: 1,
                  selectBgColor: "rgba(255, 255, 255, 1)",
                  selectFontColor: "rgba(0,0,0,.4)",
                  placeHolderFontColor: "rgba(0,0,0,1)",
                  liFontColor: "rgba(0,0,0,1)",
                  primaryLiBg: "rgba(255,255,255,0.8)",
                  selectLiBg: "rgba(61, 130, 242, 1)",
                  searchType: "searchSelect",
                  borderBottomLeftRadius: 5,
                  color: "rgba(0,0,0,0.4)"
                }),
                new Input({
                  top: 68,
                  left: 144,
                  width: 400,
                  height: 46,
                  elementInLayoutId: 2,
                  borderWidth: 1,
                  borderColor: "#999",
                  searchType: "searchInput"
                }),
                new Button({
                  top: 68,
                  left: 444,
                  width: 100,
                  height: 46,
                  elementInLayoutId: 3,
                  content: "搜索",
                  searchType: "searchButton",
                  borderTopRightRadius: 5,
                  borderBottomRightRadius: 5
                }),
                new Radio({
                  rect_id: 0,
                  top: 114,
                  left: 44,
                  width: 500,
                  elementInLayoutId: 4,
                  searchType: "searchRadio",
                  color: "rgba(255,255,255,1)",
                  hoverColor: "rgba(255,255,255,1)",
                  radioLists: [
                    {
                      name: "书名",
                      content: "书名"
                    },
                    {
                      name: "作者",
                      content: "作者"
                    },
                    {
                      name: "出版社",
                      content: "出版社"
                    }
                  ]
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
